"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const currency_1 = require("../constants/currency");
const parse_1 = require("../utils/parse");
const COMPANY_NAME = 'Deliveroo Netherlands BV';
const DUTCH_COURIER_LABEL = 'Leverancier';
const INVOICE_NAME_FLAG = 'Te betalen aan';
const INVOICE_PERIOD_FLAG = 'Diensten gelevered in de periode';
const SUMMARY_START_FLAG = 'Samenvatting';
const ADJUSTMENTS_EXCLUDED_LABELS = ['Totaal', 'Betaling per bestelling', 'Totaal excl. BTW'];
const HEADER_END_FLAG = 'vergoeding';
const ADJUSTMENTS_START_FLAG = 'Fee Adjustments';
const ADDITIONAL_LINE_START_FLAGS = ['wednesda'];
const getShifts = ({ text, zone }) => parse_1.getDataFromShiftTable(text, zone, 'en-GB', HEADER_END_FLAG, ADJUSTMENTS_START_FLAG, ADDITIONAL_LINE_START_FLAGS);
const getPeriod = ({ text, zone }) => parse_1.getPeriodFromHeader(text, INVOICE_PERIOD_FLAG, ':', '-', { zone, locale: 'en-GB' });
const getName = ({ text }) => parse_1.getNameFromHeader(text, INVOICE_NAME_FLAG);
const getAdjustments = ({ text }) => parse_1.getDataFromAdjustmentTable(text, SUMMARY_START_FLAG, ADJUSTMENTS_EXCLUDED_LABELS);
exports.default = {
    getShifts,
    getPeriod,
    getName,
    getAdjustments,
    currency: currency_1.EUR,
    flags: { with: [COMPANY_NAME, DUTCH_COURIER_LABEL] },
};
//# sourceMappingURL=nl-NL.js.map